/*
 *
 * ForgotPasswordPage RequestForm
 *
 */

import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { StyledForm, ButtonGroup } from './styledComponents';
import validate from './requestValidate';

import Button from 'components/Button';
import InputField from 'components/InputField';

const RequestForm = ({ handleSubmit, pristine, submitting }) => (
  <StyledForm onSubmit={handleSubmit}>
    <Field
      name='email'
      type='email'
      component={InputField}
      label='Email Address'
      placeholder='email@example.com'
    />
    <ButtonGroup>
      <Button type='submit' disabled={submitting}>
        Start Password Reset
      </Button>
    </ButtonGroup>
  </StyledForm>
);

export default reduxForm({
  form: 'forgotPasswordRequest',
  validate
})(RequestForm);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/RequestForm.js